import { useCallback, useState } from "react";

import { LocalAudioTrack } from "twilio-video";

import { SELECTED_AUDIO_INPUT_KEY } from "../../../../constants";
import useIsTrackEnabled from "../useIsTrackEnabled/useIsTrackEnabled";
import useVideoContext from "../useVideoContext/useVideoContext";

export default function useLocalAudioToggle() {
  const { room, localTracks, getLocalAudioTrack, onError } = useVideoContext();
  const localParticipant = room?.localParticipant;
  const audioTrack = localTracks.find((track) => track.kind === "audio") as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);
  const [isPublishing, setIsPublishing] = useState(false);

  const toggleAudioEnabled = useCallback(() => {
    if (!isPublishing) {
      if (audioTrack) {
        audioTrack.isEnabled ? audioTrack.disable() : audioTrack.enable();
      } else {
        setIsPublishing(true);
        getLocalAudioTrack(window.localStorage.getItem(SELECTED_AUDIO_INPUT_KEY) || undefined)
          .then((track: LocalAudioTrack) => localParticipant?.publishTrack(track))
          .catch(onError)
          .finally(() => {
            setIsPublishing(false);
          });
      }
    }
  }, [audioTrack, localParticipant, getLocalAudioTrack, isPublishing, onError]);

  return [isEnabled, toggleAudioEnabled] as const;
}
